import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { adminLogin, setAdminToken, getAdminToken } from "../lib/api";

export default function AdminLogin() {
    const navigate = useNavigate();
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    React.useEffect(() => {
        if (getAdminToken()) navigate("/admin", { replace: true });
    }, [navigate]);

    const submit = async (e) => {
        e.preventDefault();
        if (!password) return;
        setLoading(true);
        try {
            const r = await adminLogin(password);
            setAdminToken(r.token);
            toast.success("Welcome back.");
            navigate("/admin", { replace: true });
        } catch (err) {
            toast.error("Wrong password.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-[#FAF9F6] px-6">
            <div className="w-full max-w-md">
                <a
                    href="/"
                    className="overline text-[#4A4643] hover:text-[#1A1A1A] transition-colors"
                    data-testid="admin-back-home"
                >
                    ← Back to site
                </a>

                <div className="mt-10 border border-[#1A1A1A]/15 bg-white p-10">
                    <div className="overline text-[#8C7C6D] mb-3">Studio Admin</div>
                    <h1 className="font-serif text-4xl font-light tracking-tight text-[#1A1A1A]">
                        Sign in.
                    </h1>
                    <p className="mt-3 text-sm text-[#4A4643] font-light">
                        Restricted to Design Desire team. Enter your shared password to
                        continue.
                    </p>

                    <form onSubmit={submit} className="mt-8 space-y-6" data-testid="admin-login-form">
                        <div>
                            <label className="dd-label">Password</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="dd-input"
                                data-testid="admin-password-input"
                                autoFocus
                            />
                        </div>
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="admin-login-submit"
                            className="btn-primary w-full justify-center disabled:opacity-50"
                        >
                            {loading ? "Signing in..." : "Sign in"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
}
